import { preventForwardPropsConfig } from '../utils/preventForwardProps.js';
import { css, styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { useDefaultedEvent } from '@fabric-app/hooks/useDefaultedEvent';
import { mediaHover } from '../constants/styled-utils.js';
import * as TabsPrimitive from '@radix-ui/react-tabs';

const TabsRoot = TabsPrimitive.Root;
const listVariants = {
  default: css([
    `background:`,
    `;padding:5px;border-radius:12px;`
  ], cssVar["color-bg-quarternary"]),
  flush: css([
    `background:transparent;padding:0;border-radius:0;gap:0.453rem;`
  ])
};
const TabsList = styled(TabsPrimitive.List).withConfig(preventForwardPropsConfig([
  "variant"
])).withConfig({
  displayName: "Tabs__TabsList",
  componentId: "sc-422b9c1a-0"
})([
  `flex-grow:1;display:inline-flex;flex-shrink:0;`,
  ``
], ({ variant = "default" }) => listVariants[variant]);
const triggerVariants = {
  default: css([
    `background:transparent;border:none;cursor:pointer;will-change:background-color,box-shadow;--tabs-trigger-hover-shadow-color:rgba(`,
    `,0.4);&[data-state='active']:not([data-state-ignore='true']){color:`,
    `;background:`,
    `;--tabs-trigger-hover-shadow-color:rgba(`,
    `,0.1);}`,
    `{&:hover:enabled{box-shadow:`,
    ` var(--tabs-trigger-hover-shadow-color) inset;}}`
  ], cssVar["color-bg-primary-rgb"], cssVar["color-text-tertiary"], cssVar["color-bg-primary"], cssVar["color-bg-octonary-rgb"], mediaHover, cssVar["shadow-spread-within"]),
  apparent: css([
    `background:rgba(`,
    `,0.03);color:`,
    `;border:1px solid transparent;border-radius:10px;padding:7px 8px;height:30px;font-size:13px;font-weight:400;gap:8px;will-change:background-color,box-shadow;&[data-state='active']:not([data-state-ignore='true']){background:rgba(`,
    `,0.08);}`,
    `{&:hover:enabled{box-shadow:`,
    ` rgba(`,
    `,0.1) inset;}}`
  ], cssVar["color-bg-contrast-reverse-rgb"], cssVar["color-text-primary"], cssVar["color-bg-contrast-reverse-rgb"], mediaHover, cssVar["shadow-spread-within"], cssVar["color-bg-octonary-rgb"])
};
const preventArrowKeyNavigation = (e) => {
  if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
    e.preventDefault();
  }
};
const TabsTrigger = styled(TabsPrimitive.Trigger).attrs((p) => {
  return {
    ...p,
    "data-state-ignore": p.ignoreState,
    ...p.disableArrowNavigation && {
      onKeyDown: useDefaultedEvent(preventArrowKeyNavigation, p.onKeyDown)
    }
  };
}).withConfig(preventForwardPropsConfig([
  "variant",
  "ignoreState",
  "disableArrowNavigation",
  "square"
])).withConfig({
  displayName: "Tabs__TabsTrigger",
  componentId: "sc-422b9c1a-1"
})([
  `display:flex;padding:6px 12px;align-items:center;justify-content:center;gap:10px;border-radius:7px;flex-shrink:0;flex-grow:1;font-size:14px;font-style:normal;font-weight:500;line-height:20px;color:`,
  `;`,
  `;transition:background-color 200ms,box-shadow 200ms;`,
  ` &:disabled{opacity:0.5;}`
], cssVar["color-text-tertiary"], ({ square }) => square ? css([
  `aspect-ratio:1 / 1;`
]) : void 0, ({ variant = "default" }) => triggerVariants[variant]);
const TabsContent = styled(TabsPrimitive.Content).withConfig({
  displayName: "Tabs__TabsContent",
  componentId: "sc-422b9c1a-2"
})([
  `display:none;&[data-state='active']{display:flex;}`
]);
const Tabs = {
  Root: TabsRoot,
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent
};

export { Tabs, TabsContent, TabsList, TabsRoot, TabsTrigger };
//# sourceMappingURL=Tabs.js.map
